/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from 'react';
import sloLogo from '../../../../assets/images/SLO_logo.png';
import AppHeader from '../../AppHeader/AppHeader';

export default function SmartLogOnHeader() {
  const sloAppInfo = {
    imgSrc: sloLogo,
    imgAlt: 'Smart Log On Logo',
    headerTitle: 'Smart Log On',
    headerHelperText: 'Unlock your work day with just your smartphone.'
  };

  return (
    <AppHeader appInfo={sloAppInfo} />
  );
}
